const PLUGIN_NAME = 'dw-content';

export { PLUGIN_NAME };
